import { render, staticRenderFns } from "./ConferenciaListAprovados.vue?vue&type=template&id=4b68ef98"
import script from "./ConferenciaListAprovados.vue?vue&type=script&lang=js"
export * from "./ConferenciaListAprovados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports